import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router, ActivatedRoute } from "@angular/router";
import { Store } from "@ngxs/store";
import { Subscription } from "rxjs";
import { AdminService } from "src/app/injectable/admin.service";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { Pageable2 } from "src/app/model/pageable2";
import { PaginatorConfig } from "src/app/model/paginatorConfig";
import { SetService } from "../modify-service/modify-service-state";

@Component({
  selector: "app-show-services",
  templateUrl: "./show-services.component.html",
  styleUrls: ["./show-services.component.scss"],
})
export class ShowServicesComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  loading = false;
  sub = false;
  emptyList = false;
  displayedColumns = ["subject", "content", "actions"];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  servicesType = new FormControl("2");
  subscription: Subscription;
  pageable: Pageable2 = new Pageable2();
  paginatorConfig: PaginatorConfig;
  filterValue = "";

  constructor(
    private adminService: AdminService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private genericErrorModalService: GenericErrorModalService
  ) {}

  ngOnInit(): void {
    if (sessionStorage.getItem("latestServiceType") == null) {
      sessionStorage.setItem("latestServiceType", "2");
    }
    this.paginatorConfig = new PaginatorConfig();
    this.pageable = {
      pageable: {
        pageNum: this.paginatorConfig.getPageNum(),
        pageSize: this.paginatorConfig.getPageSize(),
      },
      sort: {
        column: this.paginatorConfig.getFilterColumn(),
        direction: this.paginatorConfig.getFilterDirection(),
      },
      filter: {
        columns: ["subject", "content"],
        value: "",
      },
    };
    if (sessionStorage.getItem("latestFilterValueServices") != null) {
      this.filterValue = sessionStorage.getItem("latestFilterValueServices");
      this.pageable.filter.value = this.filterValue;
      this.dataSource.filter = this.filterValue.trim().toLowerCase();
    }
    if (sessionStorage.getItem("latestServiceType") != null) {
      this.servicesType = new FormControl(
        sessionStorage.getItem("latestServiceType")
      );
    }
    this.getServices();
  }

  getServices() {
    this.loading = true;
    this.adminService.getAllServices().subscribe(
      (value) => {
        this.loading = false;
        const list = value.list;
        if (list.length == 0) this.emptyList = true;
        //this.dataSource = new MatTableDataSource<any>();
        // Setta la traduzione italiana per ogni Servizio //
        list.forEach((element) => {
          element.subject = element.translates.find(
            (x) => x.lang == "IT"
          )?.subject;
          element.content = element.translates.find(
            (x) => x.lang == "IT"
          )?.content;
        });
        ////////////////////////////////////////////////////
        this.dataSource.data = list;
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            // case 'subject': {
            //   return item.subject.toLowerCase();
            // }
            // case 'content': {
            //   return item.content.toLowerCase();
            // }
            default: {
              return item[property];
            }
          }
        };
      },
      (error) => {
        this.loading = false;
        console.error(error);
        this.genericErrorModalService.open(
          "Errore nel caricamento della lista dei Servizi",
          error
        );
      }
    );
  }

  insertServiceDialog() {
    this.router.navigate(["services/insert"]);
  }

  onServiceDetails(service) {
    this.router.navigate([service.id], { relativeTo: this.route });
    this.store.dispatch(new SetService(service));
  }

  onServiceDelete(service) {
    const dialogRef = this.dialog.open(DialogContentDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.adminService.deleteService(service.id).subscribe((data) => {
          this.getServices();
        });
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3500,
      panelClass: "custom-snackbar",
    });
  }

  onFilterClear() {
    this.filterValue = "";
  }

  onFiltering() {
    this.pageable.filter.value = this.filterValue;
    this.dataSource.filter = this.filterValue.trim().toLowerCase();
    sessionStorage.setItem("latestFilterValueServices", this.filterValue);
    // this.getServices();
  }

  onSearchKeydown(event) {
    if (event.key === "Enter") {
      if (this.filterValue.length == 0 || this.filterValue.length > 3) {
        this.pageable.filter.value = this.filterValue;
        this.dataSource.filter = this.filterValue.trim().toLowerCase();
        sessionStorage.setItem("latestFilterValueServices", this.filterValue);
        // this.getServices();
      }
    }
  }

  setServiceType(val) {
    sessionStorage.setItem("latestServiceType", val);
  }
}

@Component({
  selector: "dialog-content-dialog",
  templateUrl: "dialog.html",
})
export class DialogContentDialog {}
